import { Field } from 'formik'
interface IGradeProps {
  name : string
  isChecked : undefined | string
}
export default function IsGrade({name , isChecked} : IGradeProps) {
  return (
    <div className=' w-full'>
    <div className="grid grid-cols-1 w-full gap-4 ">
     
        <label
        
          className="flex items-center gap-2 text-[16px] font-medium text-gray-5"
        >
          <Field type="checkbox" name={name} value="true" checked = {isChecked} />
          محصولات با درجه کیفیت مشخص
        </label>
     
    </div>
    <div className="w-[90%]  flex" />
   
  </div>
  )
}
